import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import slice from 'ramda/src/slice';
import Button from '@components/@core/AnimatedButton';
import Pagination from '@components/@core/Pagination';
import EmptyCompany from './EmptyCompany';
import CompanyItem from './CompanyItem';

const VendorSearchCompanies = ({ data, type, onPage, onSeeAll }) => {
    const companyList = data?.data ?? [];
    const companies = type === 'sub' ? slice(0, 1, companyList) : companyList;

    return (
        <div className="vendor-search-companies">
            <div className="d-h-start">
                <p className="dsl-b18 bold me-2">Companies</p>
                <p className="dsl-p12">{`(${data?.total ?? companyList.length})`}</p>
            </div>
            {isEmpty(companies) ? (
                <EmptyCompany />
            ) : (
                <>
                    {companies.map((company, index) => (
                        <CompanyItem key={`product-${index}`} data={company} type={type === 'sub' ? 'simple' : 'detail'} />
                    ))}
                    {type === 'sub' ? (
                        <div className="d-h-end">
                            <Button type="link" name="SEE ALL" onClick={onSeeAll} />
                        </div>
                    ) : (
                        <Pagination current={data?.current_page ?? 1} pers={[]} total={data?.last_page ?? 0} onChange={onPage} />
                    )}
                </>
            )}
        </div>
    );
};

VendorSearchCompanies.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.array,
    }),
    type: PropTypes.oneOf(['sub', 'full']),
    onSeeAll: PropTypes.func,
    onPage: PropTypes.func,
};

VendorSearchCompanies.defaultProps = {
    data: { data: [] },
    type: 'sub',
    onSeeAll: () => {},
    onPage: () => {},
};

export default memo(VendorSearchCompanies);
